export enum Buttons {
    BOTTOM_FACE = 0,
    RIGHT_FACE = 1,
    TOP_FACE = 3,
    LEFT_FACE = 2,

    UP_PAD = 12,
    RIGHT_PAD = 15,
    DOWN_PAD = 13,
    LEFT_PAD = 14,

    SELECT = 8,
    START = 9,
    
    HOME = 16,

    LEFT_STICK = 10,
    RIGHT_STICK = 11,

    LEFT_SHOULDER = 4,
    RIGHT_SHOULDER = 5,

    LEFT_TRIGGER = 6,
    RIGHT_TRIGGER = 7,
}
